import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { Comp, Theme, useTheme } from '@redsift/design-system';

import { DotProps, DotVariant } from './types';
import { StyledDot } from './styles';
import { monochrome } from '../../scheme';
import { DotDatum } from '../../types';

const COMPONENT_NAME = 'Dot';
const CLASSNAME = 'redsift-dot';

export const Dot: Comp<DotProps, SVGGElement> = forwardRef((props, ref) => {
  const { color = monochrome, data, isSelected: propsIsSelected, onClick, role } = props;

  const {
    className,
    labelDecorator = (datum: DotDatum) => {
      return datum.data.key[2] !== undefined && datum.data.key[2] !== null
        ? datum.data.key[2]
        : `${datum.data.key[0]},${datum.data.key[1]}`;
    },
    scaleX,
    scaleY,
    variant = DotVariant.plain,
    children,
    ...forwardedProps
  } = props;

  const theme = useTheme();

  const isSelectable = role === 'option';
  const isDeselected = isSelectable && propsIsSelected === false;

  return (
    <StyledDot
      labelDecorator={labelDecorator}
      {...forwardedProps}
      ref={ref}
      className={classNames(Dot.className, className)}
      $clickable={Boolean(onClick)}
      $variant={variant}
      $theme={theme}
    >
      <circle
        cx={scaleX(data.x as any)}
        cy={scaleY(data.y as any)}
        r={data.r}
        fill={
          variant === DotVariant.hollow
            ? `var(--redsift-color-neutral-${theme === Theme.light ? 'white' : 'x-dark-grey'})`
            : isDeselected
            ? 'var(--redsift-color-neutral-light-grey)'
            : color
        }
        stroke={isDeselected ? 'var(--redsift-color-neutral-light-grey)' : color}
        strokeWidth={variant === DotVariant.hollow ? '2' : '0'}
      />
      {children}
    </StyledDot>
  );
});
Dot.className = CLASSNAME;
Dot.displayName = COMPONENT_NAME;
